import { render, staticRenderFns } from "./DeleteGroupModal.vue?vue&type=template&id=3e85c690&scoped=true"
import script from "./DeleteGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteGroupModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteGroupModal.vue?vue&type=style&index=0&id=3e85c690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85c690",
  null
  
)

export default component.exports